import * as React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

function MatrixRequiredAnswersInfo(props) {
	const {question, intl} = props
	const transposed = question.transposed;
	const minColumns = question.columnsMin;
	const minRows = question.rowsMin;

	return <React.Fragment />

	if (!minRows && !minColumns) {
		return <React.Fragment />
	}

	return (
		<div>
			{minColumns > 0 && !transposed && <p className={"color-default"}>{intl.formatMessage({id: 'question.matrix.columnsMin'})} {minColumns}</p>}
			{minRows > 0 && !transposed && <p className={"color-default"}>{intl.formatMessage({id: 'question.matrix.rowsMin'})} {minRows}</p>}
			{minColumns > 0 && transposed && <p className={"color-default"}>{intl.formatMessage({id: 'question.matrix.rowsMin'})} {minColumns}</p>}
			{minRows > 0 && transposed && <p className={"color-default"}>{intl.formatMessage({id: 'question.matrix.columnsMin'})} {minRows}</p>}
		</div>
	);
}

MatrixRequiredAnswersInfo.propTypes = {
	question: PropTypes.any
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(MatrixRequiredAnswersInfo));